import { ActiveTool } from 'types/AppState';

export const directLinkedTools: string[] = [
  ActiveTool.Text,
  ActiveTool.RatioFormat,
  ActiveTool.Audio,
  ActiveTool.Templates,
  ActiveTool.PhotoSidebar
];
